/***
 *
 * IMPORTANT: This file MUST be imported before all files
 * NOTE: You likely want to change all versions of instrument.js
 */

import * as Sentry from '@sentry/react'
import { Route } from 'react-router-dom'

if (
  process.env.REACT_APP_APP_ENV === 'production' ||
  process.env.REACT_APP_APP_ENV === 'staging'
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    ignoreErrors: ['ChunkLoadError'],
    environment: process.env.REACT_APP_APP_ENV,
  })
}

/**
 * A higher order component that wraps the Route component from react-router-dom with Sentry error handling.
 * @see https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v4-5/
 */
export const SentryRoute = Sentry.withSentryRouting(Route)
